import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { axios } from "~/core/axios";
import { REACT_QUERY_KEY } from "~/core/constants/common";
import { BackendApiResponse } from "~/core/types/backend-api-response.type";

import { SubscriptionStatus } from "../enums";
import { Subscription } from "../types";

export const useFetchSubscription = () => {
  return useQuery({
    queryKey: [REACT_QUERY_KEY.SUBSCRIPTION],
    queryFn: async () => {
      const { data } =
        await axios.get<BackendApiResponse<Subscription>>("/subscription");
      return (
        data.data ?? {
          status: SubscriptionStatus.INACTIVE,
        }
      );
    },
    retry: false,
    refetchOnMount: true,
    refetchOnWindowFocus: "always",
    placeholderData: keepPreviousData,
  });
};

export const useInvalidateSubscription = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: [REACT_QUERY_KEY.SUBSCRIPTION],
    });
  };
};
